import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface MarkdownPreviewProps {
  value?: string | null
}

const markdownComponents = {
  h1: ({ node, ...props }: any) => (
    <h1 className="mb-3 mt-4 text-xl font-semibold text-[#141414]" {...props} />
  ),
  h2: ({ node, ...props }: any) => (
    <h2 className="mb-2 mt-4 text-lg font-semibold text-[#141414]" {...props} />
  ),
  h3: ({ node, ...props }: any) => (
    <h3
      className="mb-2 mt-3 text-base font-semibold text-[#141414]"
      {...props}
    />
  ),
  h4: ({ node, ...props }: any) => (
    <h4
      className="mb-2 mt-3 text-sm font-semibold text-[#141414]"
      {...props}
    />
  ),
  p: ({ node, ...props }: any) => <p className="my-2" {...props} />,
  ul: ({ node, ...props }: any) => (
    <ul className="my-3 list-disc space-y-1 pl-6" {...props} />
  ),
  ol: ({ node, ...props }: any) => (
    <ol className="my-3 list-decimal space-y-1 pl-6" {...props} />
  ),
  blockquote: ({ node, ...props }: any) => (
    <blockquote
      className="my-3 border-l-4 border-slate-300 pl-3 text-slate-700"
      {...props}
    />
  ),
  a: ({ node, ...props }: any) => (
    <a className="text-blue-700 underline" target="_blank" rel="noreferrer" {...props} />
  ),
  code: ({ node, inline, className, ...props }: any) =>
    inline ? (
      <code
        className="rounded bg-slate-100 px-1 py-0.5 font-mono text-[13px]"
        {...props}
      />
    ) : (
      <code className={className} {...props} />
    ),
  pre: ({ node, ...props }: any) => (
    <pre
      className="my-3 overflow-x-auto rounded bg-slate-100 p-3 text-[13px]"
      {...props}
    />
  ),
  table: ({ node, ...props }: any) => (
    <div className="my-3 overflow-x-auto">
      <table className="w-full border-collapse text-left" {...props} />
    </div>
  ),
  th: ({ node, ...props }: any) => (
    <th className="border border-slate-200 bg-slate-50 px-2 py-1 font-semibold" {...props} />
  ),
  td: ({ node, ...props }: any) => (
    <td className="border border-slate-200 px-2 py-1" {...props} />
  ),
}

export const MarkdownPreview = ({ value }: MarkdownPreviewProps) => (
  <div className="h-full overflow-y-auto pr-2.5 text-sm leading-relaxed text-[#141414]">
    <ReactMarkdown
      components={markdownComponents}
      remarkPlugins={[remarkGfm]}
      skipHtml={true}
    >
      {String(value || '')}
    </ReactMarkdown>
  </div>
)
